var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58329 2.29175C5.55622 2.29175 2.29163 5.55634 2.29163 9.58342C2.29163 13.6105 5.55622 16.8751 9.58329 16.8751C13.6104 16.8751 16.875 13.6105 16.875 9.58342C16.875 5.55634 13.6104 2.29175 9.58329 2.29175ZM1.04163 9.58342C1.04163 4.86598 4.86586 1.04175 9.58329 1.04175C14.3007 1.04175 18.125 4.86598 18.125 9.58342C18.125 11.7172 17.3426 13.6682 16.049 15.1653L18.7752 17.8915C19.0193 18.1356 19.0193 18.5313 18.7752 18.7754C18.5312 19.0194 18.1354 19.0194 17.8914 18.7754L15.1651 16.0491C13.6681 17.3427 11.7171 18.1251 9.58329 18.1251C4.86586 18.1251 1.04163 14.3008 1.04163 9.58342Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifer);
export default __webpack_public_path__ + "static/media/Magnifer.64d80cb5ab8bbe6f13b33a320bae3cba.svg";
export { ForwardRef as ReactComponent };